module.exports = __webpack_public_path__ + "static/media/right-arrow.c28ab7b3.svg";